<template>
    <aside class="settings-content settings-company">
        <Loading v-if="is_loading" />
        <!-- handle img -->

        <Scrollbar class="data-list" :show_bar="true">
            <div class="title">Company</div>
            <Usage :canShowPlan="!cantEditCompany"/>
           
            <Form :schema="schema" @submit="submit" :values="user_data" v-slot="{ errors, success }" class="user-form-wrap"
                :class="{ 'is-error': is_error , 'disabeld-box': $store.state.merchant_disabeld }" ref="form">

                <div class="inside-title">Basic Information</div>

                <div class="item" style=" min-height: 72px;">
                    <label class="label">Company</label>
                    <p class="name" v-if="!is_change_name">
                        <strong>{{ pre_name }}</strong>
                        <span v-if="!$store.state.merchant_disabeld && !cantEditCompany" @click="is_change_name = true">Change</span>
                    </p>
                    <div class="input-wrap" v-show="is_change_name">
                        <Field type="text" k="name" placeholder="Company name" :default_value="user_data.name"
                            :error_msg="errors.name" :is_success="success.name" @update="update"
                            :ref="(el) => { els.push(el) }" />
                        <span @click="is_change_name = false">Cancel</span>
                        <Button class="leave" type="submit" color="dark-blue" size="32"
                            :is_disabled="user_data.name === pre_name && $store.state.merchant_disabeld" :border_r="6">Save</Button>
                    </div>
                </div>

                <div class="item item2">
                    <div class="logo-wrap-box">
                        <div :class="['logo-wrap']" v-for="(v, k) in img_arr" :key="k">
                            <div :class="['text', v.text_class]">
                                <h4 v-html="v.name"></h4>
                                <p v-html="v.text"></p>
                                <p class="error-msg" v-if="v.is_error" v-html="v.error_msg"></p>
                                <el-button v-if="!$store.state.merchant_disabeld && !cantEditCompany" size="small"
                                    @click="upload(k)">Upload</el-button>
                                <el-button v-if="v.is_reset && v.img && !$store.state.merchant_disabeld" class="reset" size="small" text @click="saveReset(v)">Save</el-button>
                                <el-button v-if="!v.is_reset && v.img && v.img.indexOf('.com/default-') === -1 && !$store.state.merchant_disabeld && !cantEditCompany"
                                    class="reset" size="small" text
                                    @click="resetImg(v)">Reset</el-button>
                            </div>

                            <div :class="['img-wrap ', v.img_class, { 'have-image': v.img }]" v-if="!cantEditCompany">
                                <input class="avatar-input" type="file" ref="file" @change="loadImage($event, v.field)"
                                    accept="image/png" v-if="!$store.state.merchant_disabeld">
                                <img v-if="v.img" :src="v.img" />
                                <div v-else :class="['img-wrap img-wrap-default', v.img_class]">
                                    {{ $store.state.user_data.merchant_account.merchant_display_name[0] }}
                                </div>
                                <i v-if="!$store.state.merchant_disabeld">
                                    <SvgIcon name="pen" />
                                </i>
                            </div>

                            <div class="img-wrap" v-else>
                                <img v-if="v.img" :src="v.img" />
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </Scrollbar>
    </aside>


    <Transition name="fade" v-show="is_show_cropper">
        <div class="logo-cropper-wrap" v-if="current_index !== -1">

            <div class="cropper-box">
                <header>
                    <h2>{{ img_arr[current_index].name }}</h2>
                    <i @click="is_show_alert_modal = true"><svg-icon name="close" /></i>
                </header>
                <div class="box">
                    <cropper ref="cropper" image-restriction="stencil" :stencil-size="stencilSize"
                        :default-size="defaultSize" @change="onChange" :stencil-props="{
                            lines: {},
                            handlers: {},
                            movable: false,
                            scalable: false,
                            aspectRatio: 1,
                        }" :debounce="false" :transitions="false" :canvas="{
    width: 600,
    height: 600,
}" :min-width="150" :min-height="150" :src="img_arr[current_index].image.src" />


                </div>
                <footer>
                    <div class="control">
                        <div class="slider">
                            <span>Zoom</span>
                            <Slider :zoom="zoom" @change="onZoom" />
                        </div>


                        <div class="rotate">
                            <span>Rotate</span>
                            <i @click="rotate(-90)"><svg-icon name="rotate" /></i>
                            <i @click="rotate(90)"><svg-icon name="rotate-right" /></i>
                        </div>
                    </div>

                    <p class="text" v-html="img_arr[current_index].text"></p>

                    <div class="btns">
                        <el-button text :key="'border'"
                            @click="upload(current_index)">Change image</el-button>
                        <el-button type="primary" @click="crop">Save</el-button >
                    </div>


                </footer>

            </div>

        </div>
    </Transition>
    <Modal :is_show="is_show_alert_modal" class="alert-modal" @click-bg="is_show_alert_modal = false">
        <div class="box">
            <header class="delete-header">Discard changes</header>
            <p>Are you sure you want to discard changes you made?</p>
            <div class="btns">
                <el-button text @click.native="is_show_alert_modal = false;">Cancel</el-button>
                <el-button type="primary"
                    @click.native="is_show_alert_modal = false; is_show_cropper = false;">Yes</el-button>
            </div>
        </div>
    </Modal>
</template>

<script>
import * as yup from 'yup';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

import Field from '@/components/ui/Field.vue';
import Form from '@/components/ui/Form.vue';
import Button from '@/components/ui/Button.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import getMimeType from '@/utils/getMimeType';
import Loading from '@/components/ui/Loading.vue';
import SvgIcon from '@/components/ui/SvgIcon.vue';
import SettingAlert from '@/components/settings/SettingAlert.vue';
import Usage from '@/components/ui/Usage.vue';
import Modal from '../ui/Modal.vue';
import Slider from '@/components/settings/Slider.vue';
import { ElButton } from 'element-plus';

export default {
    name: 'Security',

    components: {
        Field,
        Form,
        Button,
        Dropdown,
        Scrollbar,
        Cropper,
        Loading,
        SvgIcon,
        SettingAlert,
        Usage,
        Modal,
        Slider,
        ElButton,
    },

    data() {
        return {
            is_change_name: false,
            is_show_alert_modal: false,
            zoom: 0,
            img_arr: [
                {
                    name: 'Logo',
                    field: 'Company',
                    img: null,
                    default_img: require('@/assets/images/company/M.png'),
                    img_class: '',
                    text_class: 'company-text',
                    img_blob: null,
                    is_reset: false,
                    text: `This will be used in the Anchor portal. Please upload a 600x600px .PNG image (max size: 200KB)`,
                    image: {
                        src: null,
                        type: null
                    },
                    is_error: false,
                    error_msg: 'Please use max 600x600px and minimum 400x400px dimension PNG. format image and filenot larger than 200kb.',
                }
            ],
            now_img_key: 0,
            now_img_aspect: 1,
            //page_data filed name need to same with img_arr[index].name
            page_data: {
                Company: {
                    name: 'Company',
                    api: 'logo',
                    key: 0,
                    now_img_aspect: 1
                },
            },
            els: [],
            user_data: {
                name: '',
            },
            schema: yup.object().shape({
                name: yup.string().required('The company name can’t leave as blank'),
            }),
            is_error: false,
            is_loading: false,
            //avarar handle
            is_show_cropper: false,
            image: {
                src: null,
                type: null
            },
            img_blob: null,
            pre_name: '',
            current_index: -1,
        }
    },

    computed: {
        //permission_work.manageSettings.permission
        permission_work(){
            return this.$store.state.user_data?.permission_list?.settingWorkspace;
        },
        cantEditCompany(){
            return this.permission_work?.editCompanyNameAndLogo?.permission !== 100 || this.permission_work.manageSettings.permission !== 100;
        },
    },

    methods: {
        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },

        stencilSize({ boundaries }) {

            return {
                width: Math.min(boundaries.height, boundaries.width) - 48,
                height: Math.min(boundaries.height, boundaries.width) - 48,
            };
        },

        onChange(result) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                const { coordinates, imageSize } = cropper;

                if (
                    imageSize.width / imageSize.height >
                    coordinates.width / coordinates.height
                ) {
                    // Determine the position of slider bullet
                    // It's 0 if the stencil has the maximum size and it's 1 if the has the minimum size
                    this.zoom =
                        (cropper.imageSize.height - cropper.coordinates.height) /
                        (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
                } else {
                    this.zoom =
                        (cropper.imageSize.width - cropper.coordinates.width) /
                        (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
                }
            }
        },

        rotate(angle) {
            this.$refs.cropper.rotate(angle);
        },

        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            };
        },

        stencilSize({ boundaries }) {
            return {
                width: Math.min(boundaries.height, boundaries.width),
                height: Math.min(boundaries.height, boundaries.width),
            };
        },


        onZoom(value) {
            const cropper = this.$refs.cropper;
            if (cropper) {
                // console.log('onZoom => ' + value);
                // cropper.zoom(Number(1));
                if (cropper.imageSize.height < cropper.imageSize.width) {
                    const minHeight = cropper.sizeRestrictions.minHeight;
                    const imageHeight = cropper.imageSize.height;
                    // Determine the current absolute zoom and the new absolute zoom
                    // to calculate the sought relative zoom value
                    cropper.zoom(
                        (imageHeight - this.zoom * (imageHeight - minHeight)) /
                        (imageHeight - value * (imageHeight - minHeight))
                    );
                } else {
                    const minWidth = cropper.sizeRestrictions.minWidth;
                    const imageWidth = cropper.imageSize.width;
                    cropper.zoom(
                        (imageWidth - this.zoom * (imageWidth - minWidth)) /
                        (imageWidth - value * (imageWidth - minWidth))
                    );
                }
            }
        },

        start() {
            if (this.$store.state.user_data) {
                let company = this.$store.state.user_data.merchant_account;
                this.img_arr[0].img = company.brand_logo;
                this.user_data.name = company.merchant_display_name;
                this.pre_name = company.merchant_display_name;

                setTimeout(() => {
                    this.els.forEach(el => {
                        el.sync();
                    });

                    setTimeout(() => {
                        this.$refs.form.init();
                    }, 300);
                }, 100);
            }
        },

        update(obj) {
            this.is_error = false;
            Object.keys(this.user_data).forEach(key => {
                if (key === obj.key) this.user_data[key] = obj.val;
            });
        },

        getImageSizeInKBFromBlob(blob) {
            const file_size = Math.round(blob.size / 1024);
            return file_size;
        },

        crop() {
            this.is_loading = true;
            const { canvas } = this.$refs.cropper.getResult();
            // console.log(canvas, canvas.width, canvas.height)

            // canvas.width = 600;
            // canvas.height = 600;

            canvas.toBlob((blob) => {
                this.img_arr[this.now_img_key].img_blob = blob;
                this.img_arr[this.now_img_key].img = URL.createObjectURL(blob)
                let name = this.img_arr[this.now_img_key].field;
                this.callUpdateApi(name);
                this.is_show_cropper = false;

            }, this.img_arr[this.now_img_key].image.type);
        },

        loadImage(event, name) {
            let vi = this
            if (name == this.page_data[name].name) {
                vi.now_img_key = this.page_data[name].key;
                vi.now_img_aspect = this.page_data[name].now_img_aspect;
            }

            // Reference to the DOM input element
            const { files } = event.target;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                console.log('files[0]',files[0])
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.img_arr[vi.now_img_key].image.src) {
                    URL.revokeObjectURL(this.img_arr[vi.now_img_key].image.src)
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);

                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.img_arr[vi.now_img_key].image = {
                        src: blob,
                        type: getMimeType(e.target.result, files[0].type),
                    };
                };
                reader.readAsArrayBuffer(files[0]);

                console.log('name??:', name)

                switch (name) {
                    case 'Company':
                        this.current_index = 0;
                        this.zoom = 0;
                        this.is_show_cropper = true;

                        break;
                }
            }
        },

        submit() {
            this.is_error = false;
            if (this.pre_name !== this.user_data.name) this.callUpdateApi('name');
        },

        callUpdateApi(name) {
            this.is_loading = true;
            //have logo,favicon,name
            let form_data = new FormData();
            let api_name = name;
            if (name === 'name') {
                form_data = this.user_data;
            }

            else if (name === this.page_data.Company.name) {
                form_data.append('brand_logo', this.img_arr[0].img_blob);
                api_name = this.page_data.Company.api;
                this.img_arr[0].is_reset = false;
            }

            //CALL API
            this.$ajax(`/settings/update-company/${api_name}`, {
                method: 'post',
                data: form_data,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                const resData = res.data.data;
                //.replace(/\\/g, '');
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Updated successfully.`);
               
                if (name === this.page_data.Company.name)
                    this.$store.state.user_data.merchant_account.brand_logo = resData.brand_logo.replace(/\\/g, '');

                if (name === 'name') {
                    this.$store.state.user_data.merchant_account.merchant_display_name = this.user_data.name;
                    this.pre_name = this.user_data.name;
                    this.is_change_name = false;
                }

                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        saveReset(item) {
            const form_data = new FormData();
            this.is_loading = true;


            switch (item.field) {
                case 'Company':
                    form_data.append('image_field_name', 'brand_logo');
                    break;
            }

            this.$ajax(`/settings/reset-company-logos`, {
                method: 'post',
                data: form_data,
            }).then(res => {
                this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Reset successfully.`);
                item.is_reset = false;
                item.is_error = false;

                switch (item.field) {
                    case 'Company':
                        this.$store.state.user_data.merchant_account.brand_logo = this.img_arr[0].img;
                        break;
                }

                this.is_loading = false;
            }).catch(err => {
                this.is_loading = false;
                if (err && err.response && err.response.data.data)
                    this.errNofity(err);
            });
        },

        async resetImg(item) {
            this.is_loading = true;
            item.is_reset = true;
            item.is_error = false;

            this.$ajax(`/settings/get-default-company-logos`, {
                method: 'get',
            }).then(res => {
                const resData = res.data.data;

                switch (item.field) {
                    case 'Company':
                        this.img_arr[0].img = resData.brand_logo;
                        break;
                }


                this.is_loading = false;
            });


        },

        errNofity(err) {
            let mes = err.response && err.response.data.data ? err.response.data.data.message : '';
            this.$notify(`<svg class="err-notify"><use xlink:href="#alert--sprite"></use></svg>${mes}`);
        },

        upload(index) {
            this.current_index = index;
            this.$refs.file[index].click();
        },

    },

    mounted() {
        this.start()
    },
}
</script>
<style lang="scss">
.settings-company {

    .flex {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .inside-title {
        font: var(--font-med-24);
        padding: 16px 0;
        border-bottom: solid 1px var(--border);
    }


    .data-list {
        padding-bottom: 20px;
    }

    .title {
        margin-bottom: 24px;
    }

    .ui-input {
        margin: 12px 0 24px 0;
    }

    .logo-wrap-box {
        margin-top: 24px;
    }

    .logo-wrap {
        display: flex;
        align-items: flex-start;
        margin: 24px 0;
        min-height: 64px;

        .img-wrap {
            width: 164px;
            height: 164px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            position: relative;

            img {
                width: 100%;
                height: auto;
                object-fit: contain;
                display: block;
            }

            .avatar-input {
                position: absolute;
                height: 100%;
                width: 100%;
                left: 0;
                opacity: 0;
                top: 0;
                z-index: 3;
                cursor: pointer;
            }

            i {
                position: absolute;
                height: 24px;
                width: 24px;
                border-radius: 50%;
                border: solid 1px var(--dark-blue);
                background: white;
                display: flex;
                align-items: center;
                justify-content: center;
                right: 5px;
                top: 5px;

                svg {
                    height: 12px;
                    width: 12px;
                    position: relative;
                    fill: var(--dark-blue);
                }
            }

            &.have-image {
                // border: none;

                input {
                    left: auto !important;
                    height: calc(100% + 15px) !important;
                    width: calc(100% + 15px) !important;
                    right: -15px !important;
                    top: -15px !important;
                }

                i {
                    right: -10px;
                    top: -10px;
                }
            }
        }

        .img-wrap-default {
            background-color: var(--black-20);
            color: var(--black-60);
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: var(--font-med);
            font-size: 54px;
        }

        .company-text {
            width: 164px;
        }

        .storefront-logo {
            width: 300px;
            height: auto;
            min-height: 64px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .favicon-img {
            width: 32px;
            height: 32px;
        }

        .text {
            font-family: var(--font);
            font-size: 14px;
            line-height: 18px;
            color: var(--black-60);
            padding-right: 16px;
            width: 260px;

            h4 {
                margin-bottom: 6px;
                font: var(--font-fg-14);
                color: var(--black-100);

                &+p {
                    margin-bottom: 10px;
                }
            }

            .error-msg {
                color: var(--alert);
                margin: 10px 0;
            }


            .reset {
                border: none;
                font-size: 12px;
                margin-left: 12px;
            }
        }

    }

    .item {
        //font-weight: 400;
        margin-top: 24px;

        .label {
            font: var(--font-med-20);

            &:after {
                content: ' *';
                color: var(--alert);
            }
        }

        .name {
            margin-top: 1.2rem;
            display: flex;
            align-items: center;

            strong {
                font: var(--font-fg-14);
            }

            span {
                margin-left: .5rem;
                color: var(--blue);
                cursor: pointer;
                font: var(--font-fg-12);

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .input-wrap {
            margin-top: .8rem;
            display: flex;
            align-items: center;

            span {
                margin: 0 1rem;
                color: var(--blue);
                cursor: pointer;
                font: var(--font-fg-12);

                &:hover {
                    text-decoration: underline;
                }
            }

            .ui-input {
                margin: 0;
                min-width: 250px;

                .err-msg-box {
                    position: absolute;
                }

                input {
                    padding: 8px;
                }
            }
        }


        .no-required {
            &:after {
                content: '';
            }
        }


        &.item2 {
            margin-top: 0;

            .logo-wrap-box {
                margin-top: 0;

                .logo-wrap {
                    margin-top: 16px;
                }
            }
        }
    }


}


.logo-cropper-wrap {
    $size: 540px;
    position: fixed;
    z-index: 999;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    background-color: rgba(#fff, .5);
    backdrop-filter: blur(5px);

    i {
        cursor: pointer;
        height: 14px;
        width: 14px;
        display: block;

        svg {
            display: block;
            height: 100%;
            width: 100%;
            fill: var(--black-50);
        }

        &:hover svg {
            fill: var(--dark-blue);
        }
    }

    .cropper-box {
        width: $size;
        background-color: white;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        box-shadow: var(--bot-4dp);
        border-radius: 16px;

        header {
            padding: 12px 18px;
            display: flex;
            align-items: center;

            h2 {
                flex: 1;
                font-size: 20px;
                font-family: var(--font-med);
                color: var(--neureal);
            }
        }

        footer {
            padding: 18px;

            .control {
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    padding-right: 5px;
                    color: var(--dark-blue);
                }

                .slider {
                    display: flex;
                    align-items: center;
                    width: 240px;
                    margin: 0 12px;

                    i {
                        height: 24px;
                        width: 24px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 3px;

                        svg {
                            height: 18px;
                            width: 18px;
                            position: relative;
                            fill: var(--dark-blue);
                        }
                    }
                }

                .rotate {
                    display: flex;
                    align-items: center;
                    margin: 0 12px;

                    i {
                        height: 24px;
                        width: 24px;
                        border: 1px solid var(--dark-blue);
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin: 0 6px;

                        svg {
                            height: 14px;
                            width: 14px;
                            position: relative;
                            fill: var(--dark-blue);
                        }
                    }
                }

                .vue3-slider .handle {
                    height: 11px !important;
                    width: 11px !important;
                    transform: scale(1) !important;
                    margin-top: -5px;
                    margin-left: -5px;
                    border-radius: 50%;
                    background-color: var('');
                }
            }

            .text {
                color: var(--black-60);
                margin: 20px 0 10px;
            }

            .btns {
                display: flex;
                align-items: center;
                justify-content: flex-end;
            }

            .ui-button {
                margin: 0 6px;
            }

            // .ui-button {
            //     width: 80px;
            //     display: block;
            //     text-align: center;
            //     margin: 12px auto 0;
            // }
        }
    }

    .box {
        width: $size;
        height: $size * .75;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: var(--black-100);
    }

    .vue-bounding-box {
        border-radius: 50%;
        overflow: hidden;
    }

}
</style>

